export default {"src":"/_next/static/media/fire-smart-designer.f55d28e6.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};